import { commarize, deunit, getUnit, round } from '../../../../../utils/number';
import { RUB_SIGN } from '../../../../../constants/symbols';
import { formatRangeValue } from '../../../../../utils/formatters';

export function getPriceLabel(min?: number, max?: number): string | undefined {
  let priceMin: string | undefined;
  const priceMax: string | undefined = max !== undefined ? commarize(max) : undefined;

  if (min !== undefined && max !== undefined) {
    if (min === 0 && max === 0) {
      return undefined;
    }

    const minUnit = getUnit(min);
    const maxUnit = getUnit(max);
    const minWithUnit = min > max || minUnit !== maxUnit;

    const minDeunited = deunit(min, minUnit);

    /* istanbul ignore next */
    if (minDeunited >= 100 && maxUnit - minUnit === 1) {
      priceMin = round(minDeunited / 1000, 1)
        .toString()
        .replace(/\./g, ',');
    } else {
      priceMin = commarize(min, !minWithUnit);
    }
  } else if (min !== undefined) {
    priceMin = commarize(min);
  }

  return formatRangeValue(priceMin, priceMax, RUB_SIGN);
}
